

















































































































import { Component, Vue } from "vue-property-decorator";
import $api from "../api";

@Component
export default class Menu extends Vue {
  private accessCount: number | string = "加载中";

  mounted() {
    this.getAccessCount();
    if (!this.$store.state.hasAccess) {
      this.addAccessCount();
    }
  }

  getAccessCount() {
    $api.students.findAccessCount().then(res => {
      if ((res as any).length > 0) {
        this.accessCount = (res as any)[0].amount;
      }
    });
  }

  addAccessCount() {
    $api.students
      .addAccessCount()
      .then(res => {
        //do nothing
      })
      .catch(error => {
        console.log(error);
      });
  }
}
